const env = window.location.hostname.includes('beta-dmp.e.kuaishou.com')
    ? 'beta'
    : process.env.REACT_APP_RUN_ENV || 'development';

const DSPMap = {
    staging: '//feat-t8088876--kuaishou-frontend-dsp.jinx.staging.kuaishou.com',
    development: '//ad-test-e.corp.kuaishou.com',
    production: '//ad.e.kuaishou.com',
    beta: '//dsp-beta3.corp.kuaishou.com',
};

const BMPMap = {
    staging: '//ad-brand-platform-test-server.staging.kuaishou.com',
    development: '//ad-brand-test3.corp.kuaishou.com',
    production: '//ad-brand.corp.kuaishou.com',
    beta: '//ad-brand-pre.corp.kuaishou.com',
};

const JINNIU_DSP = {
    staging: '//ad-esp.staging.kuaishou.com',
    development: '//master--kuaishou-frontend-esp.jinx.corp.kuaishou.com',
    production: '//niu.e.kuaishou.com',
    beta: '//beta-niu.e.kuaishou.com',
};

const LSPMap = {
    staging: '//ad-lsp.staging.kuaishou.com',
    development: '//ad-lsp.staging.kuaishou.com',
    production: '//local.e.kuaishou.com',
    beta: '//local.e.kuaishou.com',
};

const KUAIZHAO_MAP = {
    staging: 'https://ad-pop.e.kuaishou.com/welcome',
    development: 'https://ad-pop.e.kuaishou.com/welcome',
    production: 'https://ad-pop.e.kuaishou.com/welcome',
    beta: 'https://ad-pop.e.kuaishou.com/welcome',
};

export const AD_E_HOST = DSPMap[env];
export const JINNIU_DSP_HOST = JINNIU_DSP[env];
export const KA_E_HOST = BMPMap[env];
export const LSP_HOST = LSPMap[env];
export const KUAIZHAO_HOST = KUAIZHAO_MAP[env];

export const DMP_E_HOST = /(\.corp\.kuaishou)|(\.test\.gifshow)/.test(window.location.href)
    ? '//ad-dmp-lzy.test.gifshow.com/'
    : '//wanxiang.e.kuaishou.com';

export const OLD_DMP_HOST = /(\.corp\.kuaishou)|(\.test\.gifshow)/.test(window.location.href)
    ? '//ad-dmp-lzy.test.gifshow.com'
    : '//dmp.e.kuaishou.com';
